// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiErrorAPIModel,
    ApiErrorAPIModelFromJSON,
    ApiErrorAPIModelToJSON,
    NewPhoneAPIModel,
    NewPhoneAPIModelFromJSON,
    NewPhoneAPIModelToJSON,
    PhoneAPIModel,
    PhoneAPIModelFromJSON,
    PhoneAPIModelToJSON,
    PhoneConfirmationAPIModel,
    PhoneConfirmationAPIModelFromJSON,
    PhoneConfirmationAPIModelToJSON,
    SimpleVerificationStatusAPIModel,
    SimpleVerificationStatusAPIModelFromJSON,
    SimpleVerificationStatusAPIModelToJSON,
} from '../models';

export interface ConfirmPhoneRequest {
    phoneConfirmationAPIModel: PhoneConfirmationAPIModel;
}

export interface UpdatePhoneRequest {
    newPhoneAPIModel: NewPhoneAPIModel;
}

/**
 * VerificationApi - interface
 * 
 * @export
 * @interface VerificationApiInterface
 */
export interface VerificationApiInterface {
    /**
     * Confirms phone via SMS code
     * @param {PhoneConfirmationAPIModel} phoneConfirmationAPIModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApiInterface
     */
    confirmPhoneRaw(requestParameters: ConfirmPhoneRequest): Promise<runtime.ApiResponse<PhoneAPIModel>>;

    /**
     * Confirms phone via SMS code
     */
    confirmPhone(phoneConfirmationAPIModel: PhoneConfirmationAPIModel): Promise<PhoneAPIModel>;

    /**
     * Gets a phone number and status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApiInterface
     */
    getPhoneRaw(): Promise<runtime.ApiResponse<PhoneAPIModel>>;

    /**
     * Gets a phone number and status
     */
    getPhone(): Promise<PhoneAPIModel>;

    /**
     * Gets simplified verification status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApiInterface
     */
    getVerificationStatusRaw(): Promise<runtime.ApiResponse<SimpleVerificationStatusAPIModel>>;

    /**
     * Gets simplified verification status
     */
    getVerificationStatus(): Promise<SimpleVerificationStatusAPIModel>;

    /**
     * Updates phone in verification profile and optionally triggers confirmation
     * @param {NewPhoneAPIModel} newPhoneAPIModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApiInterface
     */
    updatePhoneRaw(requestParameters: UpdatePhoneRequest): Promise<runtime.ApiResponse<PhoneAPIModel>>;

    /**
     * Updates phone in verification profile and optionally triggers confirmation
     */
    updatePhone(newPhoneAPIModel: NewPhoneAPIModel): Promise<PhoneAPIModel>;

}

/**
 * 
 */
export class VerificationApi extends runtime.BaseAPI implements VerificationApiInterface {

    /**
     * Confirms phone via SMS code
     */
    async confirmPhoneRaw(requestParameters: ConfirmPhoneRequest): Promise<runtime.ApiResponse<PhoneAPIModel>> {
        if (requestParameters.phoneConfirmationAPIModel === null || requestParameters.phoneConfirmationAPIModel === undefined) {
            throw new runtime.RequiredError('phoneConfirmationAPIModel','Required parameter requestParameters.phoneConfirmationAPIModel was null or undefined when calling confirmPhone.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/verification/phone/confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PhoneConfirmationAPIModelToJSON(requestParameters.phoneConfirmationAPIModel),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PhoneAPIModelFromJSON(jsonValue));
    }

    /**
     * Confirms phone via SMS code
     */
    async confirmPhone(phoneConfirmationAPIModel: PhoneConfirmationAPIModel): Promise<PhoneAPIModel> {
        const response = await this.confirmPhoneRaw({ phoneConfirmationAPIModel: phoneConfirmationAPIModel });
        return await response.value();
    }

    /**
     * Gets a phone number and status
     */
    async getPhoneRaw(): Promise<runtime.ApiResponse<PhoneAPIModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/verification/phone`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PhoneAPIModelFromJSON(jsonValue));
    }

    /**
     * Gets a phone number and status
     */
    async getPhone(): Promise<PhoneAPIModel> {
        const response = await this.getPhoneRaw();
        return await response.value();
    }

    /**
     * Gets simplified verification status
     */
    async getVerificationStatusRaw(): Promise<runtime.ApiResponse<SimpleVerificationStatusAPIModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/verification/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SimpleVerificationStatusAPIModelFromJSON(jsonValue));
    }

    /**
     * Gets simplified verification status
     */
    async getVerificationStatus(): Promise<SimpleVerificationStatusAPIModel> {
        const response = await this.getVerificationStatusRaw();
        return await response.value();
    }

    /**
     * Updates phone in verification profile and optionally triggers confirmation
     */
    async updatePhoneRaw(requestParameters: UpdatePhoneRequest): Promise<runtime.ApiResponse<PhoneAPIModel>> {
        if (requestParameters.newPhoneAPIModel === null || requestParameters.newPhoneAPIModel === undefined) {
            throw new runtime.RequiredError('newPhoneAPIModel','Required parameter requestParameters.newPhoneAPIModel was null or undefined when calling updatePhone.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/verification/phone`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NewPhoneAPIModelToJSON(requestParameters.newPhoneAPIModel),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PhoneAPIModelFromJSON(jsonValue));
    }

    /**
     * Updates phone in verification profile and optionally triggers confirmation
     */
    async updatePhone(newPhoneAPIModel: NewPhoneAPIModel): Promise<PhoneAPIModel> {
        const response = await this.updatePhoneRaw({ newPhoneAPIModel: newPhoneAPIModel });
        return await response.value();
    }

}
